<script>
import plyr from '../partials/blocks/video.vue';
import animation from '../partials/components/animate.vue';
import magnetic from '../partials/components/Magnetic.vue';
import hero from '../partials/modules/Hero.vue';
import wavyLine from '../partials/components/wavy-line.vue';
import socialShare from '../partials/components/social-share.vue';
import newsletter from '../partials/modules/newsletter.vue';
import parallaxBg from '../partials/components/ParallaxBg.vue';
import zoomIn from '../partials/components/animations/ZoomIn.vue';

export default {
    components: {
        plyr,
        animation,
        magnetic,
        hero,
        wavyLine,
        socialShare,
        newsletter,
        parallaxBg,
        zoomIn
    },

    props: {
        sound: {
            default: null
        }
    },

    data() {
        return {
            audio: null,
            start: 'top bottom',
            end: 'bottom top',
            markers: false,
            volume: 0.1,
            inView: false,
            playing: false,
        }
    },

    mounted() {
        if (!this.sound) {
            return;
        }

        this.audio = new Howl({
            src: this.sound,
            loop: true
        });

        ScrollTrigger.create({
            trigger: this.$refs.articleBody,
            start: this.start,
            end: this.end,
            markers: this.markers,

            onToggle: self => {
                if (self.isActive) {
                    this.inView = true;
                    this.play();

                } else {
                    this.inView = false;
                    this.stop();
                }

            },
        });
    },

    methods: {
        toggle() {
            if (this.playing) {
                this.stop();
            } else {
                this.play();
            }
        },

        play() {
            if (!this.playing && this.inView) {
                this.playing = true;
                this.audio.play();
                this.audio.fade(0, this.volume, 1000);
            }
        },

        stop() {
            if (this.playing) {
                this.audio.fade(this.volume, 0, 1000);

                setTimeout(() => {
                    this.audio.pause();
                    this.playing = false;
                }, 1100);
            }
        },

        pause() {
            this.audio.fade(this.volume, 0, 1000);

            setTimeout(() => {
                this.audio.pause();
                this.playing = false;
            }, 1100);
        },

        resume() {
            this.playing = true;
            this.audio.play();
            this.audio.fade(0, this.volume, 1000);
        },
    }

};
</script>
